// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__rCs4d","root":"styles_root__Q_m18","headline":"styles_headline__d5J_m"};